export enum ApplicationContext {
  JAAS = 'jaas',
  JTMS = 'jtms'
}

export interface ApplicationContextState {
  apiState: {};
  applicationContext: ApplicationContext | undefined;
}
